import {FORM_DIRECTIVES, REACTIVE_FORM_DIRECTIVES, FORM_PROVIDERS} from "@angular/forms";
import {AlertComponent, MODAL_DIRECTIVES, BS_VIEW_PROVIDERS} from "ng2-bootstrap/ng2-bootstrap";
import {Component, OnInit} from "@angular/core";
import {Dragula, DragulaService} from "ng2-dragula/ng2-dragula";
import {Router} from "@angular/router";
import {InfractionTypeService} from "../../service/infractionType.service";
import {InfractionType} from "../../domain/infractionType";

import { LoginService } from '../../service/login.service';
import { User } from '../../domain/user';
/**
 * .
 * Created by jlado on 1/9/16.
 */
@Component({
    selector: 'config-infractionTypes',
    template: require('./config.infractionTypes.component.html'),
    styles: [require('./config.infractionTypes.component.css')],
    directives: [
        FORM_DIRECTIVES,
        REACTIVE_FORM_DIRECTIVES,
        AlertComponent,
        MODAL_DIRECTIVES,
        Dragula
    ],
    providers: [FORM_PROVIDERS],
    viewProviders: [
        BS_VIEW_PROVIDERS,
        DragulaService
    ],
})
export class ConfigInfractionTypesComponent implements OnInit{

    private data:InfractionType[];

    public infractionTypeSelected:InfractionType;

    public successMessage:string;
    public error:any;

    public loading:boolean;
    private deleteMode:boolean;
    private isAdmin:boolean;
    private userLogged: User;

    constructor(private router:Router,
                private infractionTypesService:InfractionTypeService,
                private dragulaService:DragulaService, private loginService: LoginService) {
        this.init();

        this.find();

        dragulaService.setOptions('infractionTypes-bag', {
            direction: 'vertical',
            /*Elements in source can be reordered*/
            copySortSource: true,
        });
        dragulaService.dropModel.subscribe(
            () => {
                this.updateOrder();
            });
    }

    private init():void {
        this.data = [];

        this.loading = false;
        this.deleteMode = false;
    }

    private updateOrder():void {
        this.data.map((infractionType) => {
            infractionType.order = this.data.indexOf(infractionType) + 1;
        });
        this.save();
    }

    public find():void {
        this.clearMessages();
        this.loading = true;
        this.infractionTypesService.getInfractionTypes().subscribe(
            (data) =>this.refreshData(data),
            () => {
                this.bindError('Ocurrió un error al buscar los tipos de infracciones.');
            });
    }

    private refreshData(data:InfractionType[]):void {
        this.data = data;
        this.loading = false;
    }

    public save():void {
        this.clearMessages();
        this.loading = true;

        this.infractionTypesService.saveAll(this.data).subscribe(
            (saved:InfractionType[]) => {
                this.loading = false;
                this.data = saved;
                if (this.deleteMode) {
                    this.deleteMode = false;
                    this.successMessage = 'El tipo de infracción se ha eliminado con éxito.';
                } else {
                    this.successMessage = 'El nuevo orden de los tipo de infracciones se guardó con éxito.';
                }
            },
            () => {
                this.bindError('Ocurrió un error al guardar el nuevo orden de los tipos de infracciones.');
            }
        );
    }

    public ngOnInit() {
        this.userLogged = this.loginService.getUserLogged();
        if ( !this.userLogged ) {
            this.loginService.getUserLoggedSubject().subscribe(
                ( userLogged ) => {
                    this.userLogged = userLogged;
                    this.updateUserLogged();
                },
                () => {
                    //Do Nothing.
                } );
        } else {
            this.updateUserLogged();
        }
    }
    

    private updateUserLogged(): void {
        if ( this.userLogged.isAdmin() ) {
            this.isAdmin = true;
        }
    }


    
    public removeInfractionType(deleteModal:any):void {
        this.clearMessages();
        this.infractionTypesService.delete(this.infractionTypeSelected.id).subscribe(
            () => {
                deleteModal.hide();
                this.removeInfractionTypeFromView(this.infractionTypeSelected);
                this.deleteMode = true;
                this.updateOrder();
            },
            () => {
                this.bindError('Ocurrió un error al eliminar el tipo de infracción.');
            });
    }

    private removeInfractionTypeFromView(infractionType:InfractionType):void {
        let index = this.data.indexOf(infractionType);
        if (index > -1) {
            this.data.splice(index, 1);
        }
        this.infractionTypeSelected = null;
    }

    public createInfractionType():void {
        this.router.navigate(['app/home/config/createInfractionType']);
    }

    public editInfractionType(infrationType:InfractionType):void {
        this.router.navigate(['app/home/config/editInfractionType', infrationType.id]);
    }

    private clearMessages():void {
        this.successMessage = null;
        this.error = null;
    }

    private bindError(messageError:string):void {
        this.loading = false;
        if (this.error == null) {
            this.error = messageError;
        } else {
            this.error = this.error.toString() + ' ' + messageError;
        }
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/config/infractionTypes/config.infractionTypes.component.ts
 **/